var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectedBaseTile)?_c('l-tile-layer',{attrs:{"url":_vm.selectedBaseTile.url,"options":{
      maxNativeZoom: _vm.maxNativeZoom,
      updateWhenIdle: false,
      zIndex: 1
    },"attribution":_vm.attribution}}):_vm._e(),(_vm.isHillTile)?_c('l-tile-layer',{attrs:{"url":"https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png","options":{
      maxNativeZoom: _vm.maxNativeZoom,
      updateWhenIdle: false,
      opacity: 0.6,
      zIndex: 2
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }